import { render } from "./editUserRole.vue?vue&type=template&id=3f88bb60"
import script from "./editUserRole.vue?vue&type=script&lang=js"
export * from "./editUserRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__